import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  Avatar
} from '@mui/material';
import recruteurGuideSteps from '../../guides/recruteurGuideSteps';
import UserGuide from '../../commun/UserGuide';
import StarIcon from '@mui/icons-material/Star';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SavingsIcon from '@mui/icons-material/Savings';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import HeaderRecruteur from '../../header/headerRec';
import './Dashboard.css';
import MissionsList  from './MissionsList';
import Chatbox from '../../commun/ChatBox';
import PeopleIcon from '@mui/icons-material/People';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Footer from '../../commun/Footer';
import LoadingPopup from "../../commun/LoadingPopup";
import axios from 'axios';

const MultiDeviseAmount = ({ montantObj }) => (
  <>
    {montantObj && Object.entries(montantObj).map(([devise, montant]) =>
      montant > 0 && (
        <Typography variant="h5" key={devise}>
          {montant.toLocaleString()} {devise}
        </Typography>
      )
    )}
  </>
);


const DashboardModern = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem('authToken');
  const recruteurName = localStorage.getItem('recruteurName');
  const navigate = useNavigate();

  const [recruteurStats, setRecruteurStats] = useState(null);
  const [missions, setMissions] = useState([]);
  const [openPrime, setOpenPrime] = useState(false);
  const [openCagnotte, setOpenCagnotte] = useState(false);
  const [openNiveau, setOpenNiveau] = useState(false);
  const [facture, setFacture] = useState([]);
  const [showGuide, setShowGuide] = useState(false);
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    fetch(`${API_BASE}/api/recruteur-stats`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setRecruteurStats(data));
    fetch(`${API_BASE}/api/missions/all`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const activeMissions = data.filter(m => m.status === 'active'); 
          setMissions(activeMissions.slice(0, 4));
        } else {
          setMissions([]);
        }
      });
      const fetchCandidatures = async () => {
        try {
          const res = await fetch(`${API_BASE}/api/recruteur/factures/${userId}`);
          const data = await res.json();
          setFacture(data);
        } catch (err) {
          console.error('Erreur de chargement des candidatures:', err);
        }
      };
  
      fetchCandidatures();
 }, []);

 useEffect(() => {
  const checkTourGuide = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/user/tour-guide`, {
        params: {  userId }
      });
      if (!res.data.tourGuideSeen) {
        setShowGuide(true);
      }
    } catch (err) {
      console.error('Erreur en récupérant le tour guide status:', err);
    }
  };

  checkTourGuide();
}, [userId]);

  const getStarsCount = (niveau) => {
  const norm = (niveau?.toLowerCase?.()) || 'débutant';
    if (norm === 'intermédiaire') return 2;
    if (norm === 'confirmé') return 3;
    if (norm === 'expert') return 4;
    if (norm === 'légende') return 5;
    return 1;
  };

  if (!recruteurStats) return 
    <LoadingPopup
        open={!recruteurStats}
        message=""
      />

  ;

  const statsData = [
    {
      label: 'Missions prises',
      value: recruteurStats.missionsPrises,
      className: 'stat-missions',
      icon: <AssignmentIcon className="stat-badge-icon" />,
    },
    {
      label: 'Candidatures en cours',
      value: recruteurStats.candidaturesPresentees,
      className: 'stat-candidats',
      icon: <PeopleIcon className="stat-badge-icon" />,
    },
    {
      label: 'En entretien',
      value: recruteurStats.enEntretien,
      className: 'stat-entretiens',
      icon: <ThumbUpIcon className="stat-badge-icon" />,
    },
    {
      label: 'Recrutées',
      value: recruteurStats.recrutes,
      className: 'stat-recrutes',
      icon: <CheckCircleIcon className="stat-badge-icon" />,
    },
  ];

  const markMissionAsRead = async (userId, missionId, token) => {
    if (!userId || !missionId || !token) return;
  
    try {
      await axios.post(
        `${API_BASE}/api/recruteur/mark-read/${userId}`,
        { missionId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
    } catch (error) {
      console.error('Erreur lors du marquage de la mission comme lue :', error);
    }
  };
  
  return (
    <Box>
      {showGuide && (
        <UserGuide
          stepsKey="recruteurDashboardGuide"
          steps={recruteurGuideSteps}
        onFinish={async () => {
           setShowGuide(false);
            try {
              await axios.patch(`${API_BASE}/api/user/tour-guide`, { userId });
            } catch (err) {
              console.error(err);
            }
          }}
          autoStart={true}
        />
      )}
      <HeaderRecruteur recruteurName={recruteurName} />
      <Box className="dashboard-container">
        <div className="dashboard-flex">

          {/* Bloc gauche : Stats + Missions */}
          <div className="dashboard-rec">
            <Typography variant="h5" mb={2}>Statistiques</Typography>
            <div className="stats-badge-flex guide-stats">
              {statsData.map((stat, i) => (
                <div className={`stat-badge-flat ${stat.className}`} key={i}>
                  <span className="stat-badge-icon">{stat.icon}</span>
                  <span className="stat-badge-content">
                    <span className="stat-badge-label">{stat.label}</span>
                    <span className="stat-badge-value">{stat.value || 0}</span>
                  </span>
                </div>
              ))}
            </div>
            <div className="guide-dernieres-missions">
            <Typography variant="h6" gutterBottom>Dernières missions</Typography>
            <MissionsList
              missions={missions}
              onView={async (id) => {
                await markMissionAsRead(userId, id, token);
                navigate(`/Recruteur/Details/${id}`);
              }}   
             />
             </div>
          </div>

          {/* Bloc droit vertical */}
          <div className="dashboard-side-vertical">
            {/* Niveau */}
            <Card className="dashboard-side-card niveau-card-modern guide-niveau">
              <div className="side-icon-wrap" style={{ background: "#c3dafe" }}>
                <MilitaryTechIcon className="side-card-icon" style={{ color: "#2d4a87" }} />
              </div>
              <CardContent>
                <div className="side-card-label">Vous êtes</div>
                <div className="side-card-value niveau-label-modern">{recruteurStats.niveau?.label || 'Débutant'}</div>
                <div className="niveau-stars">
                  {[...Array(5)].map((_, i) => (
                    <StarIcon
                      key={i}
                      className={i < getStarsCount(recruteurStats.niveau?.label) ? "star-yellow" : "star-grey"}
                    />
                  ))}
                </div>
                <Button
                  onClick={() => setOpenNiveau(true)}
                  size="small"
                  variant="outlined"
                  className="side-card-btn"
                >EN SAVOIR PLUS</Button>
              </CardContent>
            </Card>
            {/* Cagnotte */}
            <Card className="dashboard-side-card cagnotte-card-modern guide-cagnotte">
              <div className="side-icon-wrap" style={{ background: "#d1f6ec" }}>
                <SavingsIcon className="side-card-icon" style={{ color: "#16a085" }} />
              </div>
              <CardContent>
                <div className="side-card-label">Ma cagnotte</div>
                <div className="side-card-value">
                  <MultiDeviseAmount montantObj={recruteurStats.cagnotte} />
                </div>
                <div className="side-card-desc">Montant disponible pour retrait</div>
                <Button
                  onClick={() => setOpenCagnotte(true)}
                  size="small"
                  variant="outlined"
                  className="side-card-btn"
                >En savoir plus</Button>
              </CardContent>
            </Card>
            {/* Prime estimée */}
            <Card className="dashboard-side-card prime-card-modern guide-prime">
              <div className="side-icon-wrap" style={{ background: "#ede7f6" }}>
                <MonetizationOnIcon className="side-card-icon" style={{ color: "#7c4dff" }} />
              </div>
              <CardContent>
                <div className="side-card-label">Gains potentiels</div>
                <div className="side-card-value">
                  <MultiDeviseAmount montantObj={recruteurStats.primeTotale} />
                </div>
                <div className="side-card-desc">Cumulé sur la base de vos profils présentés.</div>
                <Button
                  onClick={() => setOpenPrime(true)}
                  size="small"
                  variant="outlined"
                  className="side-card-btn"
                >En savoir plus</Button>
              </CardContent>
            </Card>
            {/* Contact 
            <Card className="dashboard-side-card contact-card-modern">
              <div className="side-icon-wrap" style={{ background: "#ffe082" }}>
                <ContactPhoneIcon className="side-card-icon" style={{ color: "#bfa800" }} />
              </div>
              <CardContent>
                <div className="side-card-label">Votre contact Cooptaleo</div>
                <div className="side-contact-name">Nom prénom</div>
                <div className="side-contact-role">Responsable</div>
                <div className="side-contact-coords">
                  <a href="tel:+33612345678" className="contact-link">+33 6 12 34 56 78</a><br />
                  <a href="mailto:contact@cooptaleo.com" className="contact-link">contact@cooptaleo.com</a>
                </div>
              </CardContent>
            </Card> */}
          </div>
        </div>

        {/* Modales */}
        <Dialog open={openPrime} onClose={() => setOpenPrime(false)} maxWidth="sm" fullWidth>
  <DialogTitle>💰 Gains potentiels</DialogTitle>
  <DialogContent dividers>
    {recruteurStats.details.primes?.length > 0 ? (
      recruteurStats.details.primes.map((item, index) => (
        <div key={index} className="recruteur-card">
          <Avatar className="facture-avatar">
            €
          </Avatar>

          <div style={{ flex: 1 }}>
            <div className="side-card-value">
              {item.missionTitre || 'Mission inconnue'}
            </div>

            <div className="side-card-desc">
              Candidat : {item.nomProfil || 'Profil inconnu'}
            </div>

            <div className="side-card-desc">
              Montant : {item.montant} {Array.isArray(item.devise) ? item.devise[0] : item.devise || 'EUR'}
            </div>

          </div>
          <div>
            <Button
              variant="outlined"
              size="small"
              onClick={() =>navigate(`/Recruteur/DetailsCandidature/${item.candidatureId}`)}
            >
              Voir détails
            </Button>
          </div>
        </div>
      ))
    ) : (
      <Typography>Aucune gains potentiels pour le moment.</Typography>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenPrime(false)}>Fermer</Button>
  </DialogActions>
</Dialog>


        <Dialog open={openCagnotte} onClose={() => setOpenCagnotte(false)} maxWidth="sm" fullWidth>
  <DialogTitle>💼 Ma cagnotte</DialogTitle>

  <DialogContent dividers>
    {facture.length > 0 ? (
      facture.map((facture, index) => (
        <div key={index} className="recruteur-card">
          <Avatar className="facture-avatar">
            #{facture.numeroFacture}
          </Avatar>

          <div style={{ flex: 1 }}>

            <div className="side-card-value">
              {facture.mission?.nomMission || 'Mission inconnue'}
            </div>

            <div className="side-card-desc">
              Montant : {facture.montant} €
            </div>

            <div className="side-card-desc">
              Statut : <strong style={{ color: facture.statutPaiement === 'Payée' ? 'green' : 'red' }}>
                {facture.statutPaiement}
              </strong>
            </div>

            <div className="side-card-desc">
              Commentaire : {facture.commentaire ? facture.commentaire : 'Aucun commentaire'}
            </div>
          </div>
        </div>

      ))
    ) : (
      <Typography>Aucune candidature trouvée.</Typography>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenCagnotte(false)}>Fermer</Button>
  </DialogActions>
</Dialog>



        <Dialog open={openNiveau} onClose={() => setOpenNiveau(false)} maxWidth="sm" fullWidth>
          <DialogTitle>⭐ Niveaux & réputation</DialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              Votre niveau indique votre engagement sur la plateforme :
            </Typography>
            <ul>
              <li><strong>Débutant</strong> : Aucun profil recruté. Merci de poursuivre vos efforts !</li>
              <li><strong>Intermédiaire</strong> : 2 profils recrutés.</li>
              <li><strong>Confirmé</strong> : 4 profils recrutés.</li>
              <li><strong>Expert</strong> : 6 profils recrutés.</li>
              <li><strong>Légende</strong> : 10 profils recrutés ou plus.</li>
            </ul>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenNiveau(false)}>Fermer</Button>
          </DialogActions>
        </Dialog>
      </Box>
      <Chatbox userRole="recruteur" />

       <Footer />
    </Box>

  );
};

export default DashboardModern;
